<div class="container-nav">
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <div class="col-12">
            <div>
                <img class="animated fadeIn fast logo-shi" src="../../../assets/images/smallshi.png" alt="">

            </div>
        </div>
    </nav>
</div>

<div class="container oops">
    <b>ESTE ENLACE DE COMPRA HA CADUCADO.</b>
    <br>
    <div class="img-oops">
        <img class="animated fadeIn fast" src="../../../assets/images/oops.png" alt="">

    </div>

    <br>
    <p>¿EMPEZAMOS DE NUEVO?</p>
    <br>
    <div class="row btn-oops" (click)="redirect()">
        <div class="col-10">
            <p>COMPRAR POR WHATSAPP</p>
        </div>
        <div class="col-2"><img class="animated fadeIn fast" src="../../../assets/images/wsp.svg" alt=""></div>
    </div>
    <!-- <div class="row btn-oops">
        <div class="col-10">
            <p>COMPRAR POR TELEGRAM</p>
        </div>
        <img class="animated fadeIn fast" src="../../../assets/images/Telegram.png" alt="">
    </div> -->
</div>